export default "__VITE_ASSET__DrUhv5Zl__"